import { render, staticRenderFns } from "./zhzfz.vue?vue&type=template&id=1514df60&scoped=true&"
import script from "./zhzfz.vue?vue&type=script&lang=js&"
export * from "./zhzfz.vue?vue&type=script&lang=js&"
import style0 from "./zhzfz.vue?vue&type=style&index=0&id=1514df60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1514df60",
  null
  
)

export default component.exports